// app/src/modules/ui/Connectivity.tsx — a small live badge that appears only when
// the device is offline, reassuring staff that the till still works and queues.
import { useEffect, useState } from "react";
import Badge from "./Badge";

export default function ConnectivityBadge() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  if (online) return null;
  return (
    <span title="No internet connection. The till keeps working — sales queue on this device and sync automatically when you're back online.">
      <Badge tone="warning" dot>Offline — sales will sync</Badge>
    </span>
  );
}
